import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {EventsService} from '../../../../../../../../../../@shared/services/events-service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {AQH_EVE_20, AQH_EVE_23} from '../../../../../../../../../../@shared/models/input.module';
import {SponsorResponse} from '../../../../../../../../../../@shared/models/response.module';
import {firstValueFrom} from 'rxjs';

@Component({
  selector: 'app-edit-sponsor',
  standalone: false,
  templateUrl: './edit-sponsor.html',
  styleUrl: './edit-sponsor.css'
})
export class EditSponsor implements OnInit, OnDestroy {
  @Input() sponsor: SponsorResponse

  sponsor_name = '';
  sponsor_description = '';

  logoFile: File | null = null;
  imageFile: File | null = null;

  logoPreview: string | null = null;
  imagePreview: string | null = null;

  constructor(private eventsService: EventsService,
              private modal: NgbActiveModal) {
  }

  ngOnInit() {
    if (this.sponsor) {
      this.sponsor_name = this.sponsor.sponsor_name || '';
      this.sponsor_description = this.sponsor.sponsor_description || '';
    }
  }

  ngOnDestroy() {
    // Clean up preview URLs to prevent memory leaks
    if (this.logoPreview) {
      URL.revokeObjectURL(this.logoPreview);
    }
    if (this.imagePreview) {
      URL.revokeObjectURL(this.imagePreview);
    }
  }

  onLogoSelected(files: File[]) {
    if (files && files.length > 0) {
      this.logoFile = files[0];
      // Clean up previous preview
      if (this.logoPreview) {
        URL.revokeObjectURL(this.logoPreview);
      }
      // Create new preview
      this.logoPreview = URL.createObjectURL(this.logoFile);
    }
  }

  onImageSelected(files: File[]) {
    if (files && files.length > 0) {
      this.imageFile = files[0];
      // Clean up previous preview
      if (this.imagePreview) {
        URL.revokeObjectURL(this.imagePreview);
      }
      // Create new preview
      this.imagePreview = URL.createObjectURL(this.imageFile);
    }
  }

  async onSave() {
    try {
      let hasChanges = false;

      // Check if name or description changed
      const nameChanged = this.sponsor_name.trim() !== this.sponsor.sponsor_name;
      const descriptionChanged = this.sponsor_description.trim() !== this.sponsor.sponsor_description;

      // Update sponsor name/description if changed
      if (nameChanged || descriptionChanged) {
        let payload: AQH_EVE_23 = {
          sponsor_id: this.sponsor.sponsor_id,
          sponsor_name: this.sponsor_name.trim(),
          sponsor_description: this.sponsor_description.trim()
        };
        await firstValueFrom(this.eventsService.updateSponsor(payload));
        hasChanges = true;
      }

      // Upload logo if provided
      if (this.logoFile) {
        let logoPayload: AQH_EVE_20 = {
          sponsor_id: this.sponsor.sponsor_id,
          image_type: 'logo',
          image: this.logoFile
        };
        await firstValueFrom(this.eventsService.uploadSponsorImage(logoPayload));
        hasChanges = true;
      }

      // Upload banner image if provided
      if (this.imageFile) {
        let imagePayload: AQH_EVE_20 = {
          sponsor_id: this.sponsor.sponsor_id,
          image_type: 'image',
          image: this.imageFile
        };
        await firstValueFrom(this.eventsService.uploadSponsorImage(imagePayload));
        hasChanges = true;
      }

      // Close modal with result
      this.modal.close(hasChanges);
    } catch (error) {
      console.error('Error updating sponsor:', error);
    }
  }

  close() {
    this.modal.close();
  }
}
